import React, { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate, useParams, Link } from 'react-router-dom';
import { useAlert } from 'react-alert'
import CenteredLoadingIcon from "../../common_components/CenteredLoadingIcon";
import HelpIcon from "../../../../../../../assets/images/researcher_app/create/create_help_icon.png";
import { TertiaryLink } from "../../common_components/Buttons";



function CreateMissionProgressBar(props) {
    // const location = useLocation();
    // const splitUrl = location.pathname.split("/");
    // const currentPage = splitUrl[splitUrl.length - 1];
    const { missionId } = useParams()
    // const interviewPaymentArray = [props.interviewPageOrder[5], props.interviewPageOrder[6], props.interviewPageOrder[7]]
    // const surveyPaymentArray = [props.surveyPageOrder[5], props.surveyPageOrder[6], props.surveyPageOrder[7]]
    const pageOrder = props.missionType == "interview" ? props.interviewPageOrder : props.missionType == "survey" ? props.surveyPageOrder : null;
    const pageNames = {
        "sessiondetails": "Session Details",
        "surveydetails": "Survey Details",
        "audience": "Audience",
        "screener": "Screener",
        "scheduling": "Scheduling",
        "survey": "Survey",
        "missionname": "Project Name",
        "payment": "Payment",
        "paymentconfirmation": "Payment",
        "cryptoconfirmation": "Payment",
    }

    const progressItems = pageOrder == null ? <CenteredLoadingIcon /> : pageOrder.map((pageUrl, index) => {
        // Check if we're on one of the payment pages.
        const onPaymentPage = (pageOrder.slice(4, 7).includes(props.currentPage.toLowerCase()))
        // IF so, then change the URL to th current page. Else, keep it as the page URL.
        // This lets us have the Payment button on the progress bar go to the current payments page if clicked. 
        // Basically we're combining the last few payments pages into one button.
        const url = (onPaymentPage && index == 4) ? props.currentPage.toLowerCase() : pageUrl
        if (index <= 4) {
            return <ProgressItem
                key={index}
                text={pageNames[pageUrl]}
                pageUrl={url}
                bottom={index == 4}
                active={props.currentPage.toLowerCase() == url.toLowerCase()}
                pageOrder={pageOrder}
                missionId={missionId}
                allowedToProgress={props.allowedToProgress}
            />
        }
    })




    return (
        <div className="fixed-progress-container" style={props.style}>
            <div className="progress-bar-container-top-div">
                <Link className="logo-container" to={{ pathname: "/dashboard" }}>
                    de<span className="logo-highlight-color-text">
                        spark
                    </span>
                </Link>
                <div className="progress-title-and-items-container">
                    <div className="progress-title">
                        Create Mission
                    </div>
                    <div className="progress-items-container">
                        {props.loadingMissionType ? <CenteredLoadingIcon /> :
                            <>{progressItems}</>
                        }
                    </div>
                </div>
            </div>
            <div className="progress-bar-container-bottom-div">
                <div className="progress-bar-help-title-div">
                    <img src={HelpIcon} />
                    <div className="progress-bar-help-title">
                        Need help?
                    </div>
                </div>
                <div className="progress-bar-help-text-div">
                    <div className="progress-bar-help-text">
                        Check our
                    </div>
                    <TertiaryLink text="FAQ" onClick={() => window.open("https://desparkwiki.notion.site/project-setup", "_blank", "noreferrer")} />
                    <div className="progress-bar-help-text">
                        for quick answers!
                    </div>
                </div>
            </div>
            <div className="progress-bar-container-bg-circle" />
        </div>
    )
}

function ProgressItem(props) {
    const navigate = useNavigate();
    const alert = useAlert();
    const textDivClassName = props.active ? "progress-text-div active" : "progress-text-div";
    const textClassName = props.active ? "progress-text" : props.allowedToProgress ? "progress-text" : "progress-text disabled";

    function clickFunction() {

        if (props.allowedToProgress) { // Call the save function.
            navigate("/createmission/" + props.missionId + "/" + props.pageUrl)
        }
    }

    return (
        <div className="progress-item-div">
            <div className="progress-icon-div" >
                {props.active ? <ActiveCircle onClick={clickFunction} /> : <InactiveCircle onClick={clickFunction} />}
                {!props.bottom && <div className="progress-line" />}
            </div>
            <div className={textDivClassName} onClick={clickFunction}>
                <div className={textClassName}>
                    {props.text}
                </div>
            </div>
        </div>
    )
}

function ActiveCircle(props) {
    return (
        <div className="clickable-circle" onClick={props.onClick}>
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                <g clipPath="url(#clip0_2052_605)">
                    <circle cx="15.6191" cy="16.7615" r="14.4881" stroke="#FEFEFE" strokeWidth="1.5" />
                    <circle cx="15.6188" cy="16.7624" r="10.6667" fill="white" stroke="white" strokeWidth="0.761905" />
                </g>
                <defs>
                    <clipPath id="clip0_2052_605">
                        <rect width="32" height="32" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        </div>
    )
}

function InactiveCircle(props) {
    return (
        <div className="clickable-circle" onClick={props.onClick}>
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" onClick={props.onClick}>
                <g clipPath="url(#clip0_2052_457)">
                    <circle cx="15.6191" cy="16.7615" r="14.4881" stroke="#FEFEFE" strokeWidth="1.5" />
                </g>
                <defs>
                    <clipPath id="clip0_2052_457">
                        <rect width="32" height="32" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        </div>
    )
}


export default CreateMissionProgressBar;